define('GameDayCore/GDModel/ValueObjects/Gamecenter/WrapupVideoList',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(WrapupVideoList);

	function getImageByType(imageList, type) {
		var desiredImage = null;
		if(imageList && imageList.image && imageList.image.length){
			imageList.image.forEach(function(image) {
				if(image.type == type) {
					desiredImage = image._text;
					return;
				}
			});
		}
		return desiredImage;
	}
	
	function getStatscast(keywords) {

		if(keywords instanceof Array) {
			keywords.forEach(function(kwd) {
				if(kwd._text  === 'vtp_player_tracking') {
					return true;
				}
			});
		} else {
			if(keywords._text  === 'vtp_player_tracking') {
				return true;
			}
		}

		return false;
	
	}

	function WrapupVideoList($data) {
		var vo = VO.ensureVO(this, WrapupVideoList),
			data = $data;

			vo.videos = [];

			if(Array.isArray(data.item)) {
				data.item.forEach(function(videoItem, index, videosArray) {
					vo.videos.push({
						blurb: videoItem.blurb,
						duration: videoItem.duration.substr(3),
						thumb: getImageByType(videoItem.images, 35),
						contentId: videoItem.content_id,
						kicker: videoItem.kicker,
						statscast: getStatscast((videoItem.keywords && videoItem.keywords.keyword) || [])
					});
				});
			} else {
				var videoItem = data.item;
				vo.videos.push({
					blurb: videoItem.blurb,
					duration: videoItem.duration.substr(3),
					thumb: getImageByType(videoItem.images, 35),
					contentId: videoItem.content_id,
					kicker: videoItem.kicker,
					statscast: getStatscast((videoItem.keywords && videoItem.keywords.keyword) || [])
				});
			}
	}

	return WrapupVideoList;
});
